// extracted by mini-css-extract-plugin
export default {"container":"logo_container__b-Oif","large":"logo_large__GL-Ny","normal":"logo_normal__k8XUy"};